import React, { useState } from 'react';
import { useSelectPortfolioSummaryRecentlyUsedAggregationFields } from '../store/sharedConfiguration/selectors';
import {
    AggregationField,
    aggregationFieldPortfolio,
} from '../aggregation/fields/aggregationFieldPortfolio';
import './AggregationFieldDropdown.scss';
import classNames from 'classnames';

import './AggregationFieldDropdown.scss';
import {
    getAggregationFieldDropdownItem,
    aggregationFieldDropdownItems,
} from '../aggregation/fields/aggregationFieldDropdownItems';
import { useDispatchUpdateWidgetConfiguration } from 'widgets/store/configuration/hooks';
import { PortfolioSummaryConfigurationState } from '../store/instances/configuration/PortfolioSummaryConfigurationState';
import { TextInput } from '@instinet-analytics/semantic-ui-components';
import Highlighter from 'react-highlight-words';
import useOnclickOutside from 'react-cool-onclickoutside';

export interface AggregationFieldDropdownProps {
    value: AggregationField;
}

export default function AggregationFieldDropdown(
    props: AggregationFieldDropdownProps
) {
    const { value } = props;

    const recentlyUsedAggregationFields =
        useSelectPortfolioSummaryRecentlyUsedAggregationFields();

    const dispatchWidgetConfigUpdate =
        useDispatchUpdateWidgetConfiguration<PortfolioSummaryConfigurationState>();

    const [isOpen, setIsOpen] = useState(false);
    const [searchText, setSearchText] = useState('');

    const text = aggregationFieldPortfolio[value]?.text;

    const toggleOpen = () => setIsOpen(!isOpen);

    const ref = useOnclickOutside(() => {
        setIsOpen(false);
    });

    const itemClick = (aggregationField: AggregationField) => {
        setIsOpen(false);
        setSearchText('');
        dispatchWidgetConfigUpdate({ aggregationField });
    };

    const onSearchChanged = (value: string) => {
        setSearchText(value);
    };

    const showMostRecent =
        searchText.trim().length === 0 &&
        recentlyUsedAggregationFields.length > 0;

    return (
        <div
            className={classNames(
                'AggregationFieldDropdown',
                isOpen && 'is-open'
            )}
            ref={ref}
        >
            <div role="listbox" className="dropdown" onClick={toggleOpen}>
                <div className="text" role="alert">
                    {text}
                </div>
                <i aria-hidden="true" className="dropdown icon" />
            </div>
            {isOpen && (
                <div className="dropdown-menu">
                    <TextInput
                        autoFocus={true}
                        className="search"
                        placeholder="Search"
                        onChange={onSearchChanged}
                        value={searchText}
                    />

                    {showMostRecent && (
                        <>
                            <div className="header">MOST RECENT</div>
                            {recentlyUsedAggregationFields.map((f) =>
                                renderItem({
                                    ...getAggregationFieldDropdownItem(f)!,
                                    key: 'recent-' + f,
                                })
                            )}
                            <div className="divider" />
                        </>
                    )}
                    {aggregationFieldDropdownItems.map(renderItem)}
                </div>
            )}
        </div>
    );

    function renderItem(f: {
        key: string;
        value: AggregationField;
        text: string;
    }) {
        const search = searchText.trim();
        const include =
            searchText === '' ||
            f.text.toLowerCase().includes(search.toLowerCase());
        return (
            include && (
                <div
                    className="item"
                    key={f.key}
                    onClick={() => itemClick(f.value)}
                >
                    <Highlighter
                        searchWords={[search]}
                        autoEscape={true}
                        textToHighlight={f.text ?? ''}
                        highlightTag={'span'}
                        highlightClassName={'match'}
                    />
                </div>
            )
        );
    }
}
